import { getCookie } from 'cookies-next/client'

export const localeCookieName = `locale`

export const getLocaleCookie = (): string | null => {
  const cookie = getCookie(localeCookieName) as string | undefined
  return cookie || null
}
